export const WiserSwitchesProductItemNo = 'WiserSwitches'